export class OrderItemToDetachedInput {
    id?: number;
  qtyRequested?: number;
  qtySupplied?: number;
  itemValue?: number;
  itemStatus?: boolean;
  itemObs?: string;
  dateSupply?: Date;
  marinaOrderId?: number;
  fuelTankFraction?: string
  fuelMeasurementType?: string;
  productId?: number;
  itemTotal?: number;
  discount?: number;
  dateReference?: Date;
  duedateDiscount?: number;
  workshopBudgetItemId?: number;
}
